/*
*   This content is licensed according to the W3C Software License at
*   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
*/



/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import PopupMenu from './popup-menu-links';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'menubar-item-links',
    baseCssClass = `js-${moduleName}`,

    selectors = {
        base: `.${baseCssClass}`
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
	PRIVATE METHODS
\* ========================================================================== */

export default class MenuBarItem {
    constructor(baseElement, menuElement) {
        this.menu = menuElement;
        this.baseElement = baseElement;

        this.popupMenu = false;

        this.hasFocus = false;
        this.hasHover = false;

        this.isMenubarItem = true;

        this.keyCode = Object.freeze({
            'TAB': 9,
            'RETURN': 13,
            'ESC': 27,
            'SPACE': 32,
            'PAGEUP': 33,
            'PAGEDOWN': 34,
            'END': 35,
            'HOME': 36,
            'LEFT': 37,
            'UP': 38,
            'RIGHT': 39,
            'DOWN': 40
        });

        this.init();
    }

    setExpanded(value) {
        if (value) {
            this.baseElement.setAttribute('aria-expanded', 'true');
        }
        else {
            this.baseElement.setAttribute('aria-expanded', 'false');
        }
    };

    handleFocus() {
        this.menu.hasFocus = true;
    };

    handleBlur() {
        this.menu.hasFocus = false;
    };

    handleMouseover() {
        this.hasHover = true;
        if (this.popupMenu) {
            this.popupMenu.Open()
        };
    };

    handleMouseout() {
        this.hasHover = false;
        if (this.popupMenu) {
            setTimeout(this.popupMenu.Close.bind(this.popupMenu, false), 300);
        }
    };

    handleKeydown(event) {
        const char = event.key;
        let flag = false;

        function isPrintableCharacter(str) {
            return str.length === 1 && str.match(/\S/);
        }

        switch (event.keyCode) {
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
            case this.keyCode.DOWN:
                if (this.popupMenu) {
                    this.popupMenu.Open();
                    this.popupMenu.setFocusToFirstItem();
                    flag = true;
                }
                break;

            case this.keyCode.LEFT:
                this.menu.setFocusToPreviousItem(this);
                flag = true;
                break;

            case this.keyCode.RIGHT:
                this.menu.setFocusToNextItem(this);
                flag = true;
                break;

            case this.keyCode.UP:
                if (this.popupMenu) {
                    this.popupMenu.Open();
                    this.popupMenu.setFocusToLastItem();
                    flag = true;
                }
                break;

            case this.keyCode.HOME:
            case this.keyCode.PAGEUP:
                this.menu.setFocusToFirstItem();
                flag = true;
                break;

            case this.keyCode.END:
            case this.keyCode.PAGEDOWN:
                this.menu.setFocusToLastItem();
                flag = true;
                break;

            case this.keyCode.TAB:
            case this.keyCode.ESC:
                this.popupMenu.Close(true);
                break;

            default:
                if (isPrintableCharacter(char)) {
                    this.menu.setFocusByFirstCharacter(this, char);
                    flag = true;
                }
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    };

    init() {
        this.baseElement.tabIndex = -1;

        this.baseElement.addEventListener('keydown', this.handleKeydown.bind(this));
        this.baseElement.addEventListener('focus', this.handleFocus.bind(this));
        this.baseElement.addEventListener('blur', this.handleBlur.bind(this));
        this.baseElement.addEventListener('mouseover', this.handleMouseover.bind(this));
        this.baseElement.addEventListener('mouseout', this.handleMouseout.bind(this));

        // Initialize pop up menus

        var nextElement = this.baseElement.nextElementSibling;

        if (nextElement && nextElement.tagName === 'UL') {
            this.popupMenu = new PopupMenu(nextElement, this);
            this.popupMenu.init();
        }
    }
}